{
  "search": "Pesquisar",
  "searchWithin": "Pesquisar em"
}
